import {
  IFintechDataIds,
  IFintechFilters,
  IFintechWeakSignalsFilters,
} from "./FintechDashboard.type";

export const initialStateFintechFilters: IFintechFilters = {
  // invest_volume_world_tier: 0,
  // invest_volume_russia_tier: 0,
  // trend_score_world: 0,
  // trend_score_world_tier: 0,
  // trend_score_russia: 0,
  // trend_score_russia_tier: 0,
  market_volume_tier: {
    value: 0,
    turnOn: false,
  },
  cagr_tier: {
    value: 0,
    turnOn: false,
  },
  market_volume_forecast_tier: {
    value: 0,
    turnOn: false,
  },
  venture_invest_volume_tier: {
    value: 0,
    turnOn: false,
  },
  // gpb: null,
};

export const initialStateFintechWeakSignalsFilters: IFintechWeakSignalsFilters =
  {
    weak_signal: {
      value: false,
      turnOn: false,
    },
    weak_signal_trend: {
      value: "rus",
      turnOn: false,
    },
  };

export const initialStateFintechDataIds: IFintechDataIds = {
  directionId: null,
  directionName: "",
  trendId: null,
  trendName: "",
};
